import React, { useEffect, useMemo, useState } from "react";
import "./policy.css";
import { PolicyStore } from "./PolicyStore";

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export default function PolicyPage({ kind = "privacy", store }) {
  const policyStore = useMemo(() => store || new PolicyStore({ source: "local" }), [store]);
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setErr("");
        const res = await policyStore.getPolicy(kind);
        if (mounted) setDoc(res);
      } catch (e) {
        if (mounted) setErr(e?.message || "Failed to load policy");
      }
    })();
    return () => {
      mounted = false;
    };
  }, [kind, policyStore]);

  return (
    <div className="paper-grid policy-wrap">
      <div className="policy-inner shadow-soft">
        {err ? (
          <div className="policy-error">
            <h1>Couldn’t load policy</h1>
            <p>{err}</p>
          </div>
        ) : !doc ? (
          <div className="policy-loading">Loading…</div>
        ) : (
          <>
            <header className="policy-header">
              <div className="policy-badge">{doc.kind === "privacy" ? "Privacy" : "Terms"}</div>
              <h1 className="policy-title">{doc.title}</h1>
              <div className="policy-meta">
                <span>Last updated: {formatDate(doc.updatedAt)}</span>
                {doc.contactEmail ? <span>• Contact: {doc.contactEmail}</span> : null}
              </div>
              {doc.intro ? <p className="policy-intro">{doc.intro}</p> : null}
            </header>

            <div className="policy-body">
              <nav className="policy-toc" aria-label="Policy table of contents">
                <div className="toc-title">On this page</div>
                <ul>
                  {doc.sections?.map((s) => (
                    <li key={s.id}>
                      <a href={`#${s.id}`}>{s.heading}</a>
                    </li>
                  ))}
                </ul>
              </nav>

              <main className="policy-sections">
                {doc.sections?.map((s) => (
                  <section key={s.id} id={s.id} className="policy-section">
                    <h2>{s.heading}</h2>
                    {Array.isArray(s.body) ? s.body.map((p, i) => <p key={i}>{p}</p>) : null}
                    {Array.isArray(s.bullets) && s.bullets.length > 0 ? (
                      <ul className="policy-bullets">
                        {s.bullets.map((b, i) => (
                          <li key={i}>{b}</li>
                        ))}
                      </ul>
                    ) : null}
                  </section>
                ))}
              </main>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
